import { formatCtrlAltShortcut } from "@/lib/keyboardShortcut";

export type AppNavShortcutKey =
  | "a"
  | "c"
  | "d"
  | "i"
  | "l"
  | "o"
  | "p"
  | "r"
  | "s"
  | "u"
  | "v";

export const APP_NAV_SHORTCUTS: Record<
  AppNavShortcutKey,
  { path: string; clearChatwootTarget?: boolean }
> = {
  a: { path: "/access-control" },
  c: { path: "/conversations", clearChatwootTarget: true },
  d: { path: "/diary" },
  i: { path: "/integrations" },
  l: { path: "/leads" },
  o: { path: "/contacts" },
  p: { path: "/properties" },
  r: { path: "/reach-out" },
  s: { path: "/settings" },
  u: { path: "/users" },
  v: { path: "/profile" },
};

/** Ctrl+Alt+M toggles light / dark mode (handled alongside the nav shortcuts). */
export const THEME_TOGGLE_SHORTCUT_KEY = "m";

export function navTooltipContent(
  label: string,
  shortcutKey?: AppNavShortcutKey,
  options?: { expanded?: boolean },
): string {
  if (!shortcutKey) return label;
  const chord = formatCtrlAltShortcut(shortcutKey);
  if (options?.expanded) return chord;
  return `${label}\n${chord}`;
}
